import { render } from "./Desc.vue?vue&type=template&id=5100fcfb&scoped=true"
const script = {}

import "./Desc.vue?vue&type=style&index=0&id=5100fcfb&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5100fcfb"

export default script